/***************************************************************************************
 * FileName      : ControlType.ts
 * Description   : 제어 유형 상수 및 타입 (JSON controlType 필드)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.10
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/equipment/*.json → devices[].controls[].controlType
 ***************************************************************************************/

// 2026.02.10 : 박은정 : 제어 유형 알려진 값 (확장 가능성 중간 → const + type)
// → 새 제어 유형(예: PID, Cascade) 추가 시 여기에 값만 추가
export const ControlTypes = {
  Command: 'Command',
  Setpoint: 'Setpoint',
} as const;

export type ControlType = (typeof ControlTypes)[keyof typeof ControlTypes] | string;

